import { render, staticRenderFns } from "./key-vocabulary-modal.vue?vue&type=template&id=0de4e7f9&scoped=true"
import script from "./key-vocabulary-modal.vue?vue&type=script&lang=js"
export * from "./key-vocabulary-modal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0de4e7f9",
  null
  
)

export default component.exports